import { UIRouter } from '@uirouter/core';
// import { UIRouter, Category } from '@uirouter/core';
// import { Visualizer } from '@uirouter/visualizer';
import {requiresAuthHook} from "./auth.hook";


export function routerConfigFn(router: UIRouter) {
  const transitionService = router.transitionService;
  requiresAuthHook(transitionService);

  // router.trace.enable(Category.TRANSITION);
  // router.plugin(Visualizer);
}
